import iconThemeColor from "../index";

const CodeIcon = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.4596 5.19697C15.5684 4.94315 15.4508 4.64921 15.197 4.54043C14.9432 4.43166 14.6492 4.54923 14.5404 4.80305L8.54043 18.803C8.43166 19.0569 8.54923 19.3508 8.80305 19.4596C9.05686 19.5684 9.3508 19.4508 9.45958 19.197L15.4596 5.19697Z"
				fill={fillColor}
			/>
			<path
				d="M8.43894 8.76055C8.57117 9.00297 8.48185 9.30669 8.23942 9.43892L3.54416 12L8.23942 14.561C8.48185 14.6933 8.57117 14.997 8.43894 15.2394C8.30671 15.4818 8.00299 15.5712 7.76057 15.4389L3.06531 12.8779C2.37044 12.4989 2.37044 11.5011 3.06531 11.1221L7.76057 8.56102C8.00299 8.42879 8.30671 8.51812 8.43894 8.76055Z"
				fill={fillColor}
			/>
			<path
				d="M15.5611 8.76055C15.4288 9.00297 15.5182 9.30669 15.7606 9.43892L20.4558 12L15.7606 14.561C15.5182 14.6933 15.4288 14.997 15.5611 15.2394C15.6933 15.4818 15.997 15.5712 16.2394 15.4389L20.9347 12.8779C21.6296 12.4989 21.6296 11.5011 20.9347 11.1221L16.2394 8.56102C15.997 8.42879 15.6933 8.51812 15.5611 8.76055Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const CodeBranch = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7 4C5.61929 4 4.5 5.11929 4.5 6.5C4.5 7.70948 5.35888 8.71836 6.5 8.94999V15.55C5.35888 15.7816 4.5 16.7905 4.5 18C4.5 19.3807 5.61929 20.5 7 20.5C8.38071 20.5 9.5 19.3807 9.5 18C9.5 16.7905 8.64112 15.7816 7.5 15.55V11.9762C7.80996 12.2339 8.17581 12.3933 8.57298 12.4867C9.17843 12.6292 9.88151 12.6245 10.6074 12.5933C10.8267 12.5839 11.0488 12.5719 11.2751 12.5598C11.8212 12.5306 12.3912 12.5 13 12.5C14.0424 12.5 14.7453 12.8969 15.2462 13.5138C15.6878 14.0577 15.9882 14.7941 16.1835 15.6364C15.2037 15.9748 14.5 16.9052 14.5 18C14.5 19.3807 15.6193 20.5 17 20.5C18.3807 20.5 19.5 19.3807 19.5 18C19.5 16.6796 18.4764 15.5983 17.1794 15.5063C16.9656 14.5412 16.6116 13.609 16.0226 12.8835C15.3334 12.0347 14.3463 11.5 13 11.5C12.3628 11.5 11.7497 11.5328 11.1941 11.5626C10.9746 11.5744 10.764 11.5856 10.5645 11.5942C9.83724 11.6255 9.25907 11.6208 8.80202 11.5133C8.36824 11.4112 8.0747 11.2243 7.8709 10.8938C7.65219 10.5391 7.5 9.9599 7.5 9V8.94999C8.64112 8.71836 9.5 7.70948 9.5 6.5C9.5 5.11929 8.38071 4 7 4ZM5.5 6.5C5.5 5.67157 6.17157 5 7 5C7.82843 5 8.5 5.67157 8.5 6.5C8.5 7.32843 7.82843 8 7 8C6.17157 8 5.5 7.32843 5.5 6.5ZM7 16.5C6.17157 16.5 5.5 17.1716 5.5 18C5.5 18.8284 6.17157 19.5 7 19.5C7.82843 19.5 8.5 18.8284 8.5 18C8.5 17.1716 7.82843 16.5 7 16.5ZM15.5 18C15.5 17.1716 16.1716 16.5 17 16.5C17.8284 16.5 18.5 17.1716 18.5 18C18.5 18.8284 17.8284 19.5 17 19.5C16.1716 19.5 15.5 18.8284 15.5 18Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const ArrowSplitIcon = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.3536 4.14645C17.1583 3.95118 16.8417 3.95118 16.6464 4.14645C16.4512 4.34171 16.4512 4.65829 16.6464 4.85355L18.7929 7H12C11.0031 7 10.3484 7.33174 9.96751 7.93672C9.63982 8.45716 9.56665 9.11939 9.50892 9.6418L9.50306 9.69478C9.43695 10.2898 9.37864 10.7249 9.18626 11.0305C9.03592 11.2692 8.75308 11.5 8 11.5H2.5C2.22386 11.5 2 11.7239 2 12C2 12.2761 2.22386 12.5 2.5 12.5H8C8.31289 12.5 8.51492 12.5585 8.65022 12.6323C8.78209 12.7042 8.8819 12.8076 8.96481 12.9521C9.14123 13.2594 9.21111 13.6804 9.30341 14.2366L9.3193 14.3322C9.41035 14.8785 9.53136 15.5585 9.91497 16.0896C10.3339 16.6697 11.0024 17 12 17L18.7929 17L16.6464 19.1464C16.4512 19.3417 16.4512 19.6583 16.6464 19.8536C16.8417 20.0488 17.1583 20.0488 17.3536 19.8536L20.3536 16.8536C20.4473 16.7598 20.5 16.6326 20.5 16.5C20.5 16.3674 20.4473 16.2402 20.3536 16.1464L17.3536 13.1464C17.1583 12.9512 16.8417 12.9512 16.6464 13.1464C16.4512 13.3417 16.4512 13.6583 16.6464 13.8536L18.7929 16L12 16C11.2476 16 10.9161 15.7678 10.7257 15.5041C10.4999 15.1915 10.4022 14.7465 10.3057 14.1678C10.298 14.1216 10.2903 14.0742 10.2824 14.0259C10.2015 13.5286 10.1036 12.9271 9.83206 12.4542C9.7553 12.3205 9.66341 12.1936 9.55306 12.0785C9.74552 11.9391 9.90447 11.7666 10.0325 11.5633C10.3602 11.0428 10.4334 10.3806 10.4911 9.8582L10.4969 9.80522C10.563 9.21024 10.6214 8.77508 10.8137 8.46953C10.9641 8.23076 11.2469 8 12 8H18.7929L16.6464 10.1464C16.4512 10.3417 16.4512 10.6583 16.6464 10.8536C16.8417 11.0488 17.1583 11.0488 17.3536 10.8536L20.3536 7.85355C20.5488 7.65829 20.5488 7.34171 20.3536 7.14645L17.3536 4.14645Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const DatabaseIcon = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.5 7.5C5.5 6.98064 5.75473 6.53113 6.12062 6.17069C6.48475 5.81199 6.986 5.51197 7.56505 5.27069C8.72535 4.78724 10.2936 4.5 12 4.5C13.7064 4.5 15.2747 4.78724 16.4349 5.27069C17.014 5.51197 17.5153 5.81199 17.8794 6.17069C18.2453 6.53113 18.5 6.98064 18.5 7.5V16.5C18.5 17.0194 18.2453 17.4689 17.8794 17.8293C17.5153 18.188 17.014 18.488 16.4349 18.7293C15.2747 19.2128 13.7064 19.5 12 19.5C10.2936 19.5 8.72535 19.2128 7.56505 18.7293C6.986 18.488 6.48475 18.188 6.12062 17.8293C5.75473 17.4689 5.5 17.0194 5.5 16.5V7.5ZM7.94967 6.19377C8.96094 5.77241 10.3927 5.5 12 5.5C13.6073 5.5 15.0391 5.77241 16.0503 6.19377C16.5571 6.40491 16.9345 6.6436 17.1776 6.88308C17.4189 7.12083 17.5 7.329 17.5 7.5C17.5 7.671 17.4189 7.87917 17.1776 8.11692C16.9345 8.3564 16.5571 8.59509 16.0503 8.80623C15.0391 9.22759 13.6073 9.5 12 9.5C10.3927 9.5 8.96094 9.22759 7.94967 8.80623C7.44294 8.59509 7.06551 8.3564 6.8224 8.11692C6.58106 7.87917 6.5 7.671 6.5 7.5C6.5 7.329 6.58106 7.12083 6.8224 6.88308C7.06551 6.6436 7.44294 6.40491 7.94967 6.19377ZM6.5 13.6481V16.5C6.5 16.671 6.58106 16.8792 6.8224 17.1169C7.06551 17.3564 7.44294 17.5951 7.94967 17.8062C8.96094 18.2276 10.3927 18.5 12 18.5C13.6073 18.5 15.0391 18.2276 16.0503 17.8062C16.5571 17.5951 16.9345 17.3564 17.1776 17.1169C17.4189 16.8792 17.5 16.671 17.5 16.5V13.6481C17.1947 13.8696 16.8332 14.0634 16.4349 14.2293C15.2747 14.7128 13.7064 15 12 15C10.2936 15 8.72535 14.7128 7.56505 14.2293C7.1668 14.0634 6.80535 13.8696 6.5 13.6481ZM17.5 12C17.5 12.171 17.4189 12.3792 17.1776 12.6169C16.9345 12.8564 16.5571 13.0951 16.0503 13.3062C15.0391 13.7276 13.6073 14 12 14C10.3927 14 8.96094 13.7276 7.94967 13.3062C7.44294 13.0951 7.06551 12.8564 6.8224 12.6169C6.58106 12.3792 6.5 12.171 6.5 12V9.14815C6.80535 9.36964 7.1668 9.56337 7.56505 9.72931C8.72535 10.2128 10.2936 10.5 12 10.5C13.7064 10.5 15.2747 10.2128 16.4349 9.72931C16.8332 9.56337 17.1947 9.36964 17.5 9.14815V12Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const FileArrowDown = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.361 15.361C14.5563 15.1658 14.5563 14.8492 14.361 14.6539C14.1658 14.4586 13.8492 14.4586 13.6539 14.6539L12.5056 15.8022L12.4999 11.9993C12.4995 11.7231 12.2753 11.4996 11.9992 11.5C11.7231 11.5004 11.4995 11.7246 11.4999 12.0008L11.5056 15.7986L10.3549 14.648C10.1596 14.4527 9.84307 14.4527 9.64781 14.648C9.45255 14.8432 9.45256 15.1598 9.64783 15.3551L11.6539 17.3611C11.8492 17.5563 12.1657 17.5563 12.361 17.361L14.361 15.361Z"
				fill={fillColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 4C6.61929 4 5.5 5.11929 5.5 6.5V17.5C5.5 18.8807 6.61929 20 8 20H16C17.3807 20 18.5 18.8807 18.5 17.5V9C18.5 8.84262 18.4259 8.69443 18.3 8.6L12.3 4.1C12.2135 4.03509 12.1082 4 12 4H8ZM6.5 6.5C6.5 5.67157 7.17157 5 8 5H11.5V7C11.5 8.38071 12.6193 9.5 14 9.5H17.5V17.5C17.5 18.3284 16.8284 19 16 19H8C7.17157 19 6.5 18.3284 6.5 17.5V6.5ZM16.5 8.5L12.5 5.5V7C12.5 7.82843 13.1716 8.5 14 8.5H16.5Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const ArrowTurnDownRight = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 8.5C6.27614 8.5 6.5 8.72386 6.5 9V11C6.5 12.933 8.067 14.5 10 14.5H16.7929L14.6464 12.3536C14.4512 12.1583 14.4512 11.8417 14.6464 11.6464C14.8417 11.4512 15.1583 11.4512 15.3536 11.6464L18.3536 14.6464C18.5488 14.8417 18.5488 15.1583 18.3536 15.3536L15.3536 18.3536C15.1583 18.5488 14.8417 18.5488 14.6464 18.3536C14.4512 18.1583 14.4512 17.8417 14.6464 17.6464L16.7929 15.5H10C7.51472 15.5 5.5 13.4853 5.5 11V9C5.5 8.72386 5.72386 8.5 6 8.5Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const ArrowTurnUpRight = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.5 18C8.5 17.7239 8.72386 17.5 9 17.5H11C12.933 17.5 14.5 15.933 14.5 14V7.20711L12.3536 9.35355C12.1583 9.54882 11.8417 9.54882 11.6464 9.35355C11.4512 9.15829 11.4512 8.84171 11.6464 8.64645L14.6464 5.64645C14.8417 5.45118 15.1583 5.45118 15.3536 5.64645L18.3536 8.64645C18.5488 8.84171 18.5488 9.15829 18.3536 9.35355C18.1583 9.54882 17.8417 9.54882 17.6464 9.35355L15.5 7.20711V14C15.5 16.4853 13.4853 18.5 11 18.5H9C8.72386 18.5 8.5 18.2761 8.5 18Z"
				fill={fillColor}
			/>
		</svg>
	);
};
const ArrowRightArrowLeft = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.3536 4.64645C17.1583 4.45118 16.8417 4.45118 16.6464 4.64645C16.4512 4.84171 16.4512 5.15829 16.6464 5.35355L18.7929 7.5H4C3.72386 7.5 3.5 7.72386 3.5 8C3.5 8.27614 3.72386 8.5 4 8.5H18.7929L16.6464 10.6464C16.4512 10.8417 16.4512 11.1583 16.6464 11.3536C16.8417 11.5488 17.1583 11.5488 17.3536 11.3536L20.3536 8.35355C20.5488 8.15829 20.5488 7.84171 20.3536 7.64645L17.3536 4.64645Z"
				fill={fillColor}
			/>
			<path
				d="M6.64645 12.6464C6.84171 12.4512 7.15829 12.4512 7.35355 12.6464C7.54882 12.8417 7.54882 13.1583 7.35355 13.3536L5.20711 15.5H20C20.2761 15.5 20.5 15.7239 20.5 16C20.5 16.2761 20.2761 16.5 20 16.5H5.20711L7.35355 18.6464C7.54882 18.8417 7.54882 19.1583 7.35355 19.3536C7.15829 19.5488 6.84171 19.5488 6.64645 19.3536L3.64645 16.3536C3.45119 16.1583 3.45119 15.8417 3.64645 15.6464L6.64645 12.6464Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const FileCode = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8536 12.6464C11.0488 12.8417 11.0488 13.1583 10.8536 13.3536L9.20711 15L10.8536 16.6464C11.0488 16.8417 11.0488 17.1583 10.8536 17.3536C10.6583 17.5488 10.3417 17.5488 10.1464 17.3536L8.14645 15.3536C7.95118 15.1583 7.95118 14.8417 8.14645 14.6464L10.1464 12.6464C10.3417 12.4512 10.6583 12.4512 10.8536 12.6464Z"
				fill={fillColor}
			/>
			<path
				d="M13.1464 13.3536C12.9512 13.1583 12.9512 12.8417 13.1464 12.6464C13.3417 12.4512 13.6583 12.4512 13.8536 12.6464L15.8536 14.6464C16.0488 14.8417 16.0488 15.1583 15.8536 15.3536L13.8536 17.3536C13.6583 17.5488 13.3417 17.5488 13.1464 17.3536C12.9512 17.1583 12.9512 16.8417 13.1464 16.6464L14.7929 15L13.1464 13.3536Z"
				fill={fillColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.5 6.5C5.5 5.11929 6.61929 4 8 4H12C12.1082 4 12.2135 4.03509 12.3 4.1L18.3 8.6C18.4259 8.69443 18.5 8.84262 18.5 9V17.5C18.5 18.8807 17.3807 20 16 20H8C6.61929 20 5.5 18.8807 5.5 17.5V6.5ZM8 5C7.17157 5 6.5 5.67157 6.5 6.5V17.5C6.5 18.3284 7.17157 19 8 19H16C16.8284 19 17.5 18.3284 17.5 17.5V9.5H14C12.6193 9.5 11.5 8.38071 11.5 7V5H8ZM12.5 5.5L16.5 8.5H14C13.1716 8.5 12.5 7.82843 12.5 7V5.5Z"
				fill={fillColor}
			/>
		</svg>
	);
};

const HourglassIcon = ({ fillColor }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9 7.00003V7.50001C9 8.3507 9.21534 8.83812 10 9.50001C10.4573 9.8858 10.7313 9.98571 11.11 10.1238C11.344 10.2091 11.618 10.3091 12 10.5C12.382 10.3091 12.656 10.2091 12.89 10.1238C13.2687 9.98571 13.5427 9.8858 14 9.50001C14.7847 8.83812 15 8.35072 15 7.50003V7.00005L9 7.00003Z"
				fill={fillColor}
			/>
			<path
				d="M9 16.5V19H15V16.5C14.898 15.188 14.012 14.5613 12 13.5C9.98077 14.5203 9.18224 15.1528 9 16.5Z"
				fill={fillColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H18C18.2761 3.5 18.5 3.72386 18.5 4C18.5 4.27614 18.2761 4.5 18 4.5H17V7.49998C17 8.76138 16.319 9.71487 15.4161 10.4765C14.7425 11.0447 13.9069 11.5384 13.0596 12C13.9069 12.4616 14.7425 12.9552 15.4161 13.5235C16.319 14.2851 17 15.2386 17 16.5V19.5H18C18.2761 19.5 18.5 19.7239 18.5 20C18.5 20.2761 18.2761 20.5 18 20.5H6C5.72386 20.5 5.5 20.2761 5.5 20C5.5 19.7239 5.72386 19.5 6 19.5H7V16.5C7 15.2386 7.68102 14.2851 8.58386 13.5235C9.2575 12.9552 10.0931 12.4616 10.9404 12C10.0931 11.5384 9.2575 11.0447 8.58386 10.4765C7.68102 9.71487 7 8.76138 7 7.49998V4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM8 4.5V7.49998C8 8.35067 8.44398 9.0502 9.22864 9.7121C9.96861 10.3363 10.9497 10.8751 12 11.4338C13.0503 10.8751 14.0314 10.3363 14.7714 9.7121C15.556 9.0502 16 8.35067 16 7.49998V4.5H8ZM16 19.5V16.5C16 15.6493 15.556 14.9498 14.7714 14.2879C14.0314 13.6637 13.0503 13.1249 12 12.5661C10.9497 13.1249 9.96861 13.6637 9.22864 14.2879C8.44398 14.9498 8 15.6493 8 16.5V19.5H16Z"
				fill={fillColor}
			/>
		</svg>
	);
};

export const ThemedCodeIcon = iconThemeColor(CodeIcon);
export const ThemedCodeBranch = iconThemeColor(CodeBranch);
export const ThemedArrowSplitIcon = iconThemeColor(ArrowSplitIcon);
export const ThemedDatabaseIcon = iconThemeColor(DatabaseIcon);
export const ThemedFileArrowDown = iconThemeColor(FileArrowDown);
export const ThemedArrowTurnDownRight = iconThemeColor(ArrowTurnDownRight);
export const ThemedArrowTurnUpRight = iconThemeColor(ArrowTurnUpRight);
export const ThemedArrowRightArrowLeft = iconThemeColor(ArrowRightArrowLeft);
export const ThemedFileCode = iconThemeColor(FileCode);
export const ThemedHourglass = iconThemeColor(HourglassIcon);
